import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { LeaveService } from 'src/app/shared/services/leaveservices/leave.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import Swal from 'sweetalert2';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { OrdinalPipe } from 'src/app/shared/pipes/ordinal.pipe';
@Component({
  selector: 'app-user-leaves-view',
  templateUrl: './user-leaves-view.component.html',
  styleUrls: ['./user-leaves-view.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule, OrdinalPipe],
  providers: [DatePipe],
})
export class UserLeavesViewComponent implements OnInit {
  showSpinner = true;
  remainleaves: any;
  userInfo: any = {};
  colormode: any;
  total_leaves: any;

  deleteValueModal: any;
  typeArr: any = [];
  public user: any = [];
  public absent: any = '';
  public checkData = false;
  public stats: any = [];
  public backgroundColor: any;
  public titleColor: any;
  public bdrColor: any;
  public statusColor: any;
  public checkEndDate = false;
  public paidLeaves = 0;
   public pendingLeaves = 0;
  public rejectedLeaves = 0;
  public renewalYear = new Date().getFullYear();
  selectedMode: any;
  datamode: any;

  refresh: any;

  current_user: any;
  current_userrole: any;
  currentUser_dep: any;
  current_userid: any;
  admindetail: any;
  adminstatus: any;
  dep: any;
  userRole: any;
  currentLeaveDetail: any;
  title: any;
  startDate: any;
  endDate: any;
  Admin_detail: any;
  rawDate = ''; // To store the raw date in 'yyyy-MM-dd' format
  displayedDate = '';
  modalImage: any;

  constructor(
    public datepipe: DatePipe,
    private leaveService: LeaveService,
    public router: Router,
    private sharedmode: SharedModeService,
    public dashboardService: DashboardService,
  ) {
    this.user_refresh();

    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();

  }

  ngOnInit(): void {
    this.getAllLeaveData();
    this.getLeaveStats();
    this.sharedmode.data$.subscribe((mode: any) => {
      this.selectedMode = mode;
    });
  }

  user_refresh() {
    this.dashboardService.getuserrefresh().then((value) => {
      this.refresh = value.data.user
      this.user = this.refresh;

    })

  }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }
  getAllLeaveData() {
    this.leaveService.getAllLeave().then((value) => {

      if (!value?.data || !Array.isArray(value.data) || value.data.length === 0) {
        this.typeArr = [];
        this.showSpinner = false;
        return; // Exit function if no leave data is found
      }

      this.typeArr = value.data;
      value.data.forEach((x: any) => {
        const obj = x;
        if (x.status == "approved") {
          if (x.leave_payment_status == "paid") {
            if (x.leave_type_id == 3) {
              if (x.shortLeave_hours) {
                this.paidLeaves = this.paidLeaves + (Math.round((Number(x.shortLeave_hours) / 8) * 100) / 100);

              }
              else {
                this.paidLeaves = this.paidLeaves + 0.5;
              }
            }
            else {
              const leaveDays = this.calculateDiff(x.start_date, x.end_date,)
              this.paidLeaves = this.paidLeaves + leaveDays;
            }
          }
        } else if (x.status == "rejected") {
          const leaveDays = this.calculateDiff(x.start_date, x.end_date)
          this.rejectedLeaves = this.rejectedLeaves + leaveDays;
        } else if (x.status === "pending") {
        if (x.leave_type_id == 3) {
          this.pendingLeaves += x.shortLeave_hours
            ? Math.round((Number(x.shortLeave_hours) / 8) * 100) / 100
            : 0.5;
        } else {
          this.pendingLeaves += this.calculateDiff(x.start_date, x.end_date);
        }
      }

      });
      this.showSpinner = false;

    });
  }



  onReset() {
    this.showSpinner = true;
    this.getAllLeaveData();
  }

  onSubmit(f: NgForm) {

    this.showSpinner = true;

    // Extract values from the form
    const title = f.value.title;
    const start_date = f.value.start_date;
    const end_Date = f.value.end_date;

    // Ensure valid start_date
    const startDate = new Date(start_date);

    // Check if startDate is valid
    let formattedStartDate: string | null = null;
    if (!isNaN(startDate.getTime())) {
      // If valid, format as yyyy-mm-dd
      const startYear = startDate.getFullYear();
      const startMonth = String(startDate.getMonth() + 1).padStart(2, '0');
      const startDay = String(startDate.getDate()).padStart(2, '0');
      formattedStartDate = `${startYear}-${startMonth}-${startDay}`;
    } else {
      // If invalid, set formattedStartDate to null
      formattedStartDate = null;
    }

    // Handle end_date
    const endDate = new Date(end_Date);

    // Check if the end_date is valid
    let formattedEndDate: string | null = null; // Default to null if invalid
    if (!isNaN(endDate.getTime())) {
      const endYear = endDate.getFullYear();
      const endMonth = String(endDate.getMonth() + 1).padStart(2, '0');
      const endDay = String(endDate.getDate()).padStart(2, '0');
      formattedEndDate = `${endYear}-${endMonth}-${endDay}`;
    } else {
      // If endDate is invalid, set formattedEndDate to null
      formattedEndDate = null;
    }


    this.leaveService.getfilterData(title, formattedStartDate, formattedEndDate).then((value) => {
      if (value.success == true && value.data.length > 0) {
        this.typeArr = value.data;
        this.showSpinner = false;

      } else if (value.success == true && value.data == '') {
        Swal.fire({
          iconHtml: ' <img src="../../../assets/images/error-modal.svg"  alt="image" >',
          title: 'No Rcord Found',
          showConfirmButton: false,
          timer: 1500,
        });
        this.showSpinner = false;

      } else {
        Swal.fire({
          iconHtml: ' <img src="../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
        this.showSpinner = false;

      }

    })
  }

  getLeaveStats() {
    this.showSpinner = true;
    this.leaveService.getStatsFilter().then((value) => {
      this.absent = value.data.absents;

      this.stats = value.data.leaves;
      if (this.stats) {
        this.checkData = true;
      }
    });

  }

  showDetails(data: any) {
    this.router.navigate(['/leaves-status'], {
      queryParams: { data: JSON.stringify(data) },
      skipLocationChange: true,
    });
  }

  deleteDetail(dataDelete: any) {
    this.deleteValueModal = dataDelete;
  }

  deleteLeave(data: any) {
    this.showSpinner = true;
    this.leaveService
      .deleteLeave(
        data.id
      )
      .then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Delete data Successfully',
            showConfirmButton: false,
            timer: 1500,
          });
          // this.router.navigate(['leaves']);

          window.location.reload();
          this.showSpinner = false;
        } else {
          Swal.fire({
            iconHtml: ' <img src="../../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
      });
    //
  }

  editLeave(data: any) {
    this.showSpinner = true;
    if (this.userInfo.theme_id == 1) {
      this.router.navigate(['/user-leaves/' + this.paidLeaves + '/' + this.rejectedLeaves], {
        queryParams: { data: JSON.stringify(data), isEdit: true },
        skipLocationChange: true,
      });
    } else if (this.userInfo.theme_id == 2) {
      this.router.navigate(['/user-leaves/' + this.paidLeaves + '/' + this.rejectedLeaves], {
        queryParams: { data: JSON.stringify(data), isEdit: true },
        skipLocationChange: true,
      });
    } else {
      this.router.navigate(['/apply-leaves/' + this.paidLeaves + '/' + this.rejectedLeaves], {
        queryParams: { data: JSON.stringify(data), isEdit: true },
        skipLocationChange: true,
      });
    }

  }

  getLeaveColor(data: any) {
    if (data == 'pending') {
      return '#BAE6FF';
    }
    if (data == 'rejected') {
      return 'rgb(251 207 209)';
    }
    if (data == 'approved') {

      return '#BCFFC3';
    }
    return '';
  }

  calculateDiff(data_1: any, data_2: any) {
    const date1 = new Date(data_1);
    const date2 = new Date(data_2);

    const days = Math.floor(
      (date2.getTime() - date1.getTime()) / 1000 / 60 / 60 / 24
    );
    return days + 1;
  }

  checkShort(end_date: any) {
    if (end_date) {

    } else {
      return true;
    }
    return false;
  }

  checkFull(end_date: any) {
    if (end_date) {
      return true;
    }
    return false;
  }

  isPaid(LeaveStatus: any) {
    if (LeaveStatus == "paid") {
      return true;
    }
    return false;
  }

  isUnPaid(LeaveStatus: any) {
    if (LeaveStatus == "unpaid") {
      return true;
    }
    return false;
  }

  getShift(shift: any) {
    if (shift == "first") {
      return "Morining";
    } else {
      return "Evening";
    }
  }

  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      debugger
      this.total_leaves = this.userInfo?.total_leaves
    })

  }


  isAdmindata(leave: any): boolean {
    let isAdminData = false
    if (leave.leave_details.length > 0) {
      return isAdminData = true
    } else {
      return isAdminData = false
    }
  }

  // Call this method in your component where needed
  isShowApprovalButtons(leave: any): boolean {
    if (leave.leave_details.length > 0) {
      // user who sign up role
      let isButtonVissible = true;
      this.current_user = JSON.parse(this.user.user_role.user_roles)
      this.current_userrole = this.current_user?.role_type
      this.currentUser_dep = this.user?.department
      this.current_userid = this.user?.id
      leave.leave_details.forEach((detail: any) => {
        this.admindetail = detail?.admin
        this.adminstatus = detail?.status
        this.dep = detail?.user_dep
        this.userRole = detail?.user_role
        if (detail.admin_id == this.current_userid || (this.userRole == this.current_userrole && this.currentUser_dep == this.dep)) {
          isButtonVissible = false; // Hide button
        }

      });
      return isButtonVissible

    } else {
      return true
    }

  }
  isShowrejectstatus(leave: any): boolean {
    if (leave.leave_details.length > 0) {
      let isLeaveStatus = true;
      this.current_user = JSON.parse(this.user.user_role.user_roles)
      this.current_userrole = this.current_user?.role_type
      this.currentUser_dep = this.user?.department
      this.current_userid = this.user?.id
      leave.leave_details.forEach((detail: any) => {
        this.admindetail = detail?.admin
        this.adminstatus = detail?.status
        this.dep = detail?.user_dep
        this.userRole = detail?.user_role
        if (this.adminstatus == 'rejected') {
          isLeaveStatus = false; // Hide button
        }
      });
      return isLeaveStatus

    } else {
      return true
    }

  }

  isPendingstatus(leave: any): boolean {
    let ispendiingStatus = true
    if (leave.leave_details.length = 0) {
      ispendiingStatus = false
      return ispendiingStatus
    } else {
      return true
    }

  }

  showLeaveDetail(detail: any) {
    this.currentLeaveDetail = detail;
  }


  remainingLeaves() {
    this.showSpinner = true;
    this.dashboardService.getRemainingLeaves().then((value) => {
      this.remainleaves = value.data.data
    })
  }

  leaveInfo() {
    this.showSpinner = true;
    this.dashboardService.getRemainingLeaves().then((value) => {
      this.remainleaves = value.data.data
      this.showSpinner = false;

    })
  }

  detailAdmin(data: any) {
    this.Admin_detail = data

  }


  openDatePicker(): void {
    const dateInput = document.getElementById('hidden-date-input') as HTMLInputElement;
    dateInput.click(); // Programmatically trigger the date picker
  }

  // Handle the date change event
  onDateChange(event: any): void {
    this.rawDate = event.target.value; // Capture the raw date in 'yyyy-MM-dd'
    this.displayedDate = this.formatDateToReadable(this.rawDate); // Format date to 'MMM dd, yyyy'
  }

  // Utility function to format the date into 'MMM dd, yyyy'
  formatDateToReadable(date: string): string {
    const parsedDate = new Date(date);
    const options: Intl.DateTimeFormatOptions = {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
    };
    return parsedDate.toLocaleDateString('en-US', options); // Example: 'Jan 01, 2025'
  }


  // On blur, format the date and set the input type back to 'text'
  onFocus(event: FocusEvent): void {
    const input = event.target as HTMLInputElement;
    input.type = 'date';
  }

  // On blur, format the date and set the input type back to 'text'
  onBlur(event: FocusEvent): void {
    const input = event.target as HTMLInputElement;
    input.type = 'text';
    const value = input.value;

    if (value) {
      const date = new Date(value);

      // Get day, month, and year
      const day = date.getDate();
      const month = date.toLocaleString('default', { month: 'short' }); // e.g. 'Jan'
      const year = date.getFullYear();

      // Format as 'Jan 2, 2025'
      const formattedDate = `${month} ${day}, ${year}`;

      // Assign formatted date to the respective field
      if (input.id === 'date-input1') {
        this.startDate = formattedDate;
      } else if (input.id === 'date-input') {
        this.endDate = formattedDate;
      }
    } else {
      // If no date is selected, reset the value
      if (input.id === 'date-input1') {
        this.startDate = '';
      } else if (input.id === 'date-input') {
        this.endDate = '';
      }
    }

    // Set the input's value to the formatted date
    input.value = input.id === 'date-input1' ? this.startDate : this.endDate;
  }


  imageModaldata(data: any) {
    this.modalImage = data
  }



}


